import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  contracts: {
    name: string;
    value: string;
    isSelected: boolean;
  }[];
  errorMessage: string;
  error: boolean;
  loading: boolean;
} = {
  contracts: [],
  error: false,
  loading: false,
  errorMessage: "",
};
const fetchGroupSpecificContracts = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_GROUP_SPECIFIC_CONTRACTS_STARTED: {
      return updateObject(state, {
        contracts: initialState.contracts,
        error: false,
        loading: true,
        errorMessage: "",
      });
    }
    case actionTypes.FETCH_GROUP_SPECIFIC_CONTRACTS_SUCCESS:
      return updateObject(state, {
        contracts: action.contracts,
        error: false,
        loading: false,
        errorMessage: "",
      });

    case actionTypes.FETCH_GROUP_SPECIFIC_CONTRACTS_FAILED:
      return updateObject(state, {
        contracts: initialState.contracts,
        error: true,
        loading: false,
        errorMessage: action.errorMessage,
      });

    default:
      return state;
  }
};

export default fetchGroupSpecificContracts;
